<template>
  <div class="user-worklog-block">
    <h3 v-if="!showAll">{{$dt('WorkLogStats.title.best','Best time loggers')}}</h3>
    <h3 v-else>{{$dt('WorkLogStats.title.all','Time log stats')}}</h3>
    <b-list-group>
      <b-list-group-item v-for="(stat, idx) in best" :key="stat.author_id"
        :class="['d-flex justify-content-between align-items-center', `wlscore best p${idx}`]">
        <b-img rounded="circle" class="profile-img" :src="`/api/user/${stat.author_id}/photo?token=${token}`" />
        {{ stat.displayName }}
        <span>
          <b-badge v-if="showAll" variant="primary" pill class="verbose">{{ stat.m2 }}</b-badge>
          <b-badge v-if="showAll" variant="primary" pill class="verbose">{{ stat.m1 }}</b-badge>
          <b-badge v-if="showAll" variant="primary" pill class="verbose">{{ stat.m0 }}</b-badge>
          <b-badge variant="danger" pill v-if="stat.missing > 8">{{ stat.missing }}</b-badge>
          <b-badge variant="primary" pill v-else-if="stat.missing > 0">{{ stat.missing }}</b-badge>
          <i v-else class="fa fa-check text-success" aria-hidden="true" />
        </span>
      </b-list-group-item>
    </b-list-group>

    <h3 v-if="worst.length > 0">Worst time loggers</h3>
    <b-list-group>
      <b-list-group-item v-for="(stat, idx) in worst" :key="stat.author_id"
        :class="['d-flex justify-content-between align-items-center', `wlscore worst p${idx}`]">
        <b-img rounded="circle" class="profile-img" :src="`/api/user/${stat.author_id}/photo?token=${token}`" />
        {{ stat.displayName }}
        <b-badge variant="danger" pill>{{ stat.missing }}</b-badge>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Services from '@/services';
// import clone from 'lodash.clonedeep';
// import moment from 'moment';
// import { SVGGantt, CanvasGantt, StrGantt } from 'gantt';

export default {
  mounted() {
    this.init();
  },
  props: {
    showAll: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      stats: [],
      polling: null,
      // chart: null,
      //   data:
    };
  },
  components: {
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),
    scoredStats() {
      const stats = [...this.stats.map((s) => {
        s.m0 = Math.round(Math.max(0, s.time_expected_0 - s.time_spent_0) / (60 * 60));
        s.m1 = Math.round(Math.max(0, s.time_expected_1 - s.time_spent_1) / (60 * 60));
        s.m2 = Math.round(Math.max(0, s.time_expected_2 - s.time_spent_2) / (60 * 60));
        s.missing = s.m0 + s.m1 + s.m2;
        return s;
      })];
      stats.sort((a, b) => { return ((a.missing < b.missing) ? -1 : (a.missing > b.missing) ? 1 : 0); });
      return stats;
    },
    best() {
      return this.scoredStats.slice(0, this.showAll ? this.scoredStats.length : 6);
    },
    worst() {
      if (this.showAll) return [];
      const stats = this.scoredStats.slice(-2);
      stats.sort((a, b) => { return -1 * ((a.missing < b.missing) ? -1 : (a.missing > b.missing) ? 1 : 0); });
      return stats.filter((s) => s.missing > 0);
    },

  },
  watch: {

  },

  beforeDestroy() {
    if (this.polling) {
      clearInterval(this.polling);
    }
  },
  methods: {
    getData() {
      Services.dash.WorkLogStats().then(({ data }) => {
        this.stats = data.data;
      });
    },
    init() {
      this.getData();
      if (this.sync) {
        this.polling = setInterval(() => {
          this.getData();
        }, this.sync * 1000);
      }
    },
  }
};

</script>

<style lang=scss>
.user-worklog-block .list-group-item {
  border-color: $gray;

  .verbose {
    visibility: hidden;
  }

  &:hover {

    .verbose {
      visibility: visible;
    }
  }
}

.user-worklog-block {
  min-width: 180px;
}

.profile-img {
  max-height: 2.4em;
  border: solid 1px white;
  margin-right: 1em;
  margin-left: -0.4em;
  margin-top: -0.1em;
  margin-bottom: -0.1em;
  z-index: 1;
}

.wlscore:nth-child(even) {
  .profile-img {
    // margin-left: -0.9em;
  }
}

.wlscore {
  font-size: 1.2em;
  padding: 0.1em 0.4em;
  overflow: visible;

}

.wlscore .badge {
  // font-size: 2em;
}

.best .profile-img {
  border-color: green;
}

.worst .profile-img {
  border-color: red;
}

.p0 .profile-img {
  // border-width: 4px;
}

.p1 .profile-img {
  // border-width: 3px;
}

.p2 .profile-img {
  // border-width: 2px;
}
</style>
